import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { HideToast, getToastNotifications } from '../../../store/toast/actions';
import { forEach } from 'lodash-es';

export const useNotifier = (): void => {
    const dispatch = useDispatch();
    const notifications = useSelector(getToastNotifications);
    const { enqueueSnackbar } = useSnackbar();
    const [displayed, setDisplayed] = useState([]);

    useEffect(() => {
        forEach(notifications, (value) => {
            if (displayed.includes(value.key)) return;
            enqueueSnackbar(value, {
                variant: value.severity,
                autoHideDuration: value.duration,
                onExited: () => {
                    dispatch(HideToast(value.key));
                    setDisplayed([...displayed.filter((key) => value.key !== key)]);
                },
            });
            setDisplayed([...displayed, value.key]);
        });
    }, [notifications]);
};
